import "../../style/common/divider.scss"

export default function Divider () {
    return (
        <div className="divider mt-6 mb-6"></div>
    )
}
